export const ESIM_INCLUSION_ID = 'loyalty_esim_benefit'

/**
 * Builds the synthetic OfferInclusion for the eSIM benefit line (append to inclusion lists).
 * description should be the formatted copy (e.g. "X GB Free Data Roaming" or similar).
 */
export function getLoyaltyEsimInclusion(description: string): App.OfferInclusion {
  return {
    id: ESIM_INCLUSION_ID,
    description,
    symbol: 'mobile_android',
  }
}
